const NS = 'CourseSimpleCard';
const CLS = 'courseSimpleCard';

export class CourseSimpleCard {
	constructor(element) {
		this.element = element;
		this.$el = $(this.element);
		this.$title = $(this.element).find('.title')
		this.title = $(this.element).find('.title').text();

		this.init();
	}

	init() {
		this.title = this.title.trim();
		if(this.title.length >= 40) {
			this.title = this.title.substring(0, 39) + '...';
			this.$title.text(this.title);
		}
	}
}
